import {
    SET_OFFRES_SALARIALES_LOADING,
    SET_OFFRES_SALARIALES_ERROR,

    FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_SUCCESS,
    FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_FAIL,

    CREATE_OFFRE_SALARIALE_SUCCESS,
    CREATE_OFFRE_SALARIALE_FAIL,

    UPDATE_OFFRE_SALARIALE_SUCCESS,
    UPDATE_OFFRE_SALARIALE_FAIL,

    DELETE_OFFRE_SALARIALE_SUCCESS,
    DELETE_OFFRE_SALARIALE_FAIL,

    DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_SUCCESS,
    DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_FAIL,

    SEND_OFFRE_SALARIALE_EMAIL_SUCCESS,
    SEND_OFFRE_SALARIALE_EMAIL_FAIL,
} from "../actions/offresSalarialesActions";

const initialState = {
    loading: false,
    error: null,
    offreByCandidature: {},
    lastEmailResult: null,
};

export default function offresSalarialesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_OFFRES_SALARIALES_LOADING:
            return { ...state, loading: action.payload };

        case SET_OFFRES_SALARIALES_ERROR:
            return { ...state, error: action.payload };

        case FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_SUCCESS: {
            const offre = action.payload;
            const candidatureId = offre?.candidatureId;
            if (!candidatureId) return { ...state, error: null };

            return {
                ...state,
                error: null,
                offreByCandidature: {
                    ...state.offreByCandidature,
                    [candidatureId]: offre,
                },
            };
        }

        case CREATE_OFFRE_SALARIALE_SUCCESS:
        case UPDATE_OFFRE_SALARIALE_SUCCESS: {
            const offre = action.payload;
            const candidatureId = offre?.candidatureId;
            if (!candidatureId) return { ...state, error: null };

            return {
                ...state,
                error: null,
                offreByCandidature: {
                    ...state.offreByCandidature,
                    [candidatureId]: offre,
                },
            };
        }

        case DELETE_OFFRE_SALARIALE_SUCCESS: {
            const candidatureId = action.payload?.candidatureId;
            if (!candidatureId) return { ...state, error: null };

            const nextMap = { ...state.offreByCandidature };
            delete nextMap[candidatureId];

            return {
                ...state,
                error: null,
                offreByCandidature: nextMap,
            };
        }

        case DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_SUCCESS:
            return { ...state, error: null };

        case SEND_OFFRE_SALARIALE_EMAIL_SUCCESS:
            return {
                ...state,
                error: null,
                lastEmailResult: action.payload,
            };

        case FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_FAIL:
        case CREATE_OFFRE_SALARIALE_FAIL:
        case UPDATE_OFFRE_SALARIALE_FAIL:
        case DELETE_OFFRE_SALARIALE_FAIL:
        case DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_FAIL:
        case SEND_OFFRE_SALARIALE_EMAIL_FAIL:
            return { ...state, error: action.payload };

        default:
            return state;
    }
}
